import Visibility from '@mui/icons-material/Visibility';
import VisibilityOff from '@mui/icons-material/VisibilityOff';
import {
  Box,
  Button,
  IconButton,
  InputAdornment,
  TextField,
  Typography,
} from '@mui/material';
import * as React from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { updateAdminPassword } from 'store/actions';
import { selectMetadata, selectToken } from 'store/selectors';

import { buttonStyle } from './ChangePassword.style';

const ChangePassword = () => {
  const dispatch = useDispatch();
  const token = useSelector(selectToken);
  const md = useSelector(selectMetadata);

  const [formData, setFormData] = React.useState({});
  const [formValid, setFormValid] = React.useState(false);

  const [showOldPassword, setShowOldPassword] = React.useState(false);
  const [showNewPassword, setShowNewPassword] = React.useState(false);

  const handleClickShowOldPassword = () => setShowOldPassword((show) => !show);
  const handleClickShowNewPassword = () => setShowNewPassword((show) => !show);

  const handleMouseDownPassword = (event) => {
    event.preventDefault();
  };

  const handleMouseUpPassword = (event) => {
    event.preventDefault();
  };

  const checkForm = () => {
    if (formData.new && formData.old) {
      setFormValid(true);
    } else {
      setFormValid(false);
    }
  };

  const updateData = (value, key) => {
    let update = formData;
    update[key] = value;

    setFormData(update);
    checkForm();
  };

  const updatePassword = () => {
    dispatch(updateAdminPassword(formData, token));
    setFormData({});
    setFormValid(false);
  };

  return (
    <Box display="flex" flexDirection="column" alignItems="center" gap={2}>
      <Typography variant="h5">Update Admin Password</Typography>
      <Typography variant="subtitle2" color="text.secondary">
        Last updated: {md.last_password_update ?? 'N/A'}
      </Typography>
      <Box display="flex" flexDirection="row" alignItems="center" gap={2}>
        <TextField
          onChange={(event) => {
            updateData(event.target.value, 'old');
          }}
          margin="dense"
          id="old_password"
          label="Old Password"
          size="small"
          type={showOldPassword ? 'text' : 'password'}
          variant="outlined"
          InputProps={{
            endAdornment: (
              <InputAdornment position="end">
                <IconButton
                  onClick={handleClickShowOldPassword}
                  onMouseDown={handleMouseDownPassword}
                  onMouseUp={handleMouseUpPassword}
                  edge="end">
                  {showOldPassword ? <VisibilityOff /> : <Visibility />}
                </IconButton>
              </InputAdornment>
            ),
          }}
        />
        <TextField
          onChange={(event) => {
            updateData(event.target.value, 'new');
          }}
          margin="dense"
          id="new_password"
          label="New password"
          size="small"
          type={showNewPassword ? 'text' : 'password'}
          variant="outlined"
          InputProps={{
            endAdornment: (
              <InputAdornment position="end">
                <IconButton
                  onClick={handleClickShowNewPassword}
                  onMouseDown={handleMouseDownPassword}
                  onMouseUp={handleMouseUpPassword}
                  edge="end">
                  {showNewPassword ? <VisibilityOff /> : <Visibility />}
                </IconButton>
              </InputAdornment>
            ),
          }}
        />
        <Button
          variant="contained"
          onClick={updatePassword}
          disabled={!formValid}
          sx={buttonStyle}>
          Update
        </Button>
      </Box>
    </Box>
  );
};

export default ChangePassword;
